/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from '@/layouts/components/navbarSearchAndPinList'
import themeConfig from '@/../themeConfig.js'
import colors from '@/../themeConfig.js'

const state = {
    isSidebarActive: true,
    breakpoint: null,
    sidebarWidth: "default",
    reduceButton: themeConfig.sidebarCollapsed,
    bodyOverlay: false,
    sidebarItemsMin: false,
    theme: themeConfig.theme || 'light',
    navbarSearchAndPinList: navbarSearchAndPinList,
    AppActiveUser: {
        id: 0,
        login_id: '',
        name: '홍길동',
        tail: '기자',
        levelText: '기자',
        level: '7',
        email: '',
        department: '',
    },
    themePrimaryColor: colors.primary,
    starredPages: navbarSearchAndPinList.data.filter((page) => page.highlightAction),
    
    accessToken: null,
    categories1: [],
    categories1_2: [],
    categories2: [],
    categories2_2: [],
    series: [],
    writer: [],
    writerAll: null,
    hrUser: null,
    states: [],
    // 송고 포털 목록. 중앙신문은 **네이버·다음 두 곳만** 송고한다.
    // ZUM · Nate 는 2026-09-04 에, 언론재단(KU) 은 2026-09-09 에 뺐다.
    // 셋 다 데일리안 계약·데일리안 계정이라 중앙신문이 쓸 수 없다
    // (KU 는 files.bigkinds.or.kr 에 데일리안 계정으로 붙고 본문 저작권도 데일리안이었다).
    // 서버도 writeArticles.js 의 ACTIVE_PORTALS 로 한 번 더 걸러낸다 —
    // 화면에서 빠뜨려도 다른 경로(예약 복원 등)로 들어오는 것을 막기 위해서다.
    // id 는 기존 값을 그대로 둔다. out_site 파싱과 매핑 테이블이 이 번호를 쓴다.
    portals: [{'id': 0, 'name': 'Naver', 'oldName': 'mna'},
              {'id': 1, 'name': 'Daum', 'oldName': 'ndaum'}],
    portalsWithAll: [{'id': 0, 'name': 'Naver', 'oldName': 'mna'},
            {'id': 1, 'name': 'Daum', 'oldName': 'ndaum'},
            {'id': 9, 'name': 'ALL', 'oldName': '(none)'}],
    maxWidth: 1200,
    calendarLabels: [
        { text: '데스크' ,value : '데스크', color: 'success' },
        { text: '평일당직', value: '평일당직', color: 'warning'},
        { text: '주말공휴일재택', value: '주말공재', color: 'danger'},
        { text: '주말공휴일현장', value: '주말공현', color: 'primary'},
    ],
    timeOffLabels: [
        { text: '데스크' ,value : '데스크', color: 'success' },
        // { text: '팀장', value: '팀장', color: 'warning'},
        { text: '기자 및 일반직원', value: '기자 및 일반직원', color: 'primary'},
    ],
    // 부서 표. member.option1 에 들어가는 값이다.
    //
    // 🔴 **여기가 정본이다.** 기자관리(MemberReporter)·휴가 대시보드(TimeOffDashboard)·
    //    뉴스리스트 사이드바가 모두 이 표를 본다. 예전에는 기자관리가 자기 복사본을
    //    따로 들고 있어, 신설 부서가 휴가 대시보드에서 빈칸으로 나왔다(2026-09-24 정리).
    // 🔴 **웹의 joongang_www/news/config/constants.js DEPARTMENTS 와 짝이다.**
    //    한쪽만 고치면 CMS 에서 지정한 부서가 기사 화면의 기자 카드에서 빈칸이 된다.
    //
    // 조직도(중앙신문_인사말_연혁_등등_260821.hwpx) + 뉴스리스트 구성
    // (중앙신문_CMS_수정안_260922) 기준. 배정자가 0명이던 경제부(g2)·문화체육부(g5)는
    // 두 문서 어디에도 없어 뺐다.
    departmentOption: [
        { text: "미분류", value: "g0" },
        { text: "편집국(데스크)", value: "desk" },
        { text: "경기본부", value: "g12" },
        { text: "인천본부", value: "g18" },
        { text: "정치부", value: "g1" },
        { text: "사회부", value: "g10" },
        { text: "산업부", value: "g20" },
        { text: "ICT융합부", value: "g21" },
        { text: "금융부", value: "g22" },
        { text: "증권부", value: "g23" },
        { text: "건설부동산부", value: "g24" },
        { text: "유통부", value: "g25" },
        // 연예스포츠부를 둘로 쪼갰다(2026-09-24). g26 의 옛 이름이 '연예스포츠부' 였고
        // 배정자가 0명이라 그대로 연예부로 쓰고, 스포츠부만 g28 로 새로 뗀다.
        { text: "연예부", value: "g26" },
        { text: "스포츠부", value: "g28" },
        { text: "국제부", value: "g27" },
        { text: "뉴미디어부", value: "g9" },
        { text: "사진부", value: "g8" },
    ],
    // 회원 권한 레벨. member.level 과 1:1 로 대응한다.
    //   11 최종관리자 / 10 관리자 / 9 데스크 / 8 일반기자 / 6 일반직원 / 3 외부기자
    //   CMS API 의 check_2_10 은 2~12 를 통과시키므로 6 이상이면 기사작성이 가능하다.
    //   '기자리스트(작성자 드롭다운) 노출' 여부는 레벨이 아니라 member.writer_type 이 정한다.
    levelOption: [
        { text: "최종관리자", value: "11" },
        { text: "관리자", value: "10" },
        { text: "데스크", value: "9" },
        { text: "일반기자", value: "8" },
        { text: "일반직원", value: "6" },
        { text: "외부기자", value: "3" },
    ],
}

export default state
